module.exports = {
    // click event
    CLICK_LINK_TYPE: 'o',
    CLICK_ACTIVITY: 'actionCall',
    CLICK_NO_DEST: 'no destination',

    // page view event
    PAGE_NAME: 'mtv|events|voting|2023-mtv-movie-and-tv-awards',
    PAGE_CHANNEL: 'events',
    PAGE_EVENT: 'M&TVAs',
    PAGE_FRANCHISE: '2023 M&TVAs',
    PAGE_SERIES: 'no-series',
    PAGE_TYPE: 'voting',
    PAGE_ACTIVITY: 'pageview',
    PAGE_VID_FRANCHISE: 'no-franchise',
    PREV_PAGE_NAME: 'n/a',
    WEB_VERSION: 'WebPlex 3.2.0',

    APP_NAME: 'M&TVAs web',
    BRAND_ID: 'mtv-us',
    LANGUAGE: 'en-us',
    COUNTRY_NAME: 'us',
    VENDOR: 'Telescope',
    MOD_NAME: 'voting_items',
    MOD_NAME_SOCIAL: 'voting',
    SOC_METHOD: 'instagram',

    // other settings
    MAX_ATTEMPTS: 10,
    RETRY_DELAY: 800
};



// WEBPACK FOOTER //
// ./app/scripts/constants/_omniture.js